import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** The mails an owner can turn off. Only what asks for a reaction. */
export type NotificationKind = 'bookings' | 'reviews'

interface NotificationPreferencesState {
  enabled: Record<NotificationKind, boolean>
  setEnabled: (kind: NotificationKind, value: boolean) => void
}

/**
 * Which e-mails the signed-in owner wants. Local only while
 * `NOTIFICATIONS_USE_API` is off (see `config.ts`).
 *
 * Not filed per venue: an owner of several wants the same mails from each,
 * and the switches belong to the person, as Claude's do.
 */
export const useNotificationPreferences =
  create<NotificationPreferencesState>()(
    persist(
      set => ({
        // On by default: a booking nobody hears about is a table nobody sets.
        enabled: { bookings: true, reviews: true },
        setEnabled: (kind, value) =>
          set(state => ({ enabled: { ...state.enabled, [kind]: value } }))
      }),
      { name: 'notification-preferences-storage' }
    )
  )
